<template>
  <v-row class="ma-0 flex-nowrap mx-4" justify="end">
    <v-menu
      v-for="(theme, themeIndex) in themes"
      :key="`theme-${themeIndex}`"
      offset-y
      :open-on-hover="theme.Children.length > 1"
    >
      <template v-slot:activator="{ on, attrs }">
        <div
          v-bind="attrs"
          v-on="on"
          class="theme"
          :class="{ 'primary-font-color': isTransparent }"
          @click="onThemeClick(theme)"
        >
        <span v-if="isTransparent" class="text-wrap text-body-1">
            {{ theme.EventTranslationName }}
          </span>
          <span v-else class="primary--text text-wrap text-body-1">
            {{ theme.EventTranslationName }}
          </span>
          <v-icon v-if="theme.Children.length > 1 && !isTransparent" right color="primary">
            keyboard_arrow_down
          </v-icon>
          <v-icon v-else-if="theme.Children.length > 1 && isTransparent" right class="primary-font-color">
            keyboard_arrow_down
          </v-icon>
        </div>
      </template>
      <v-list v-if="theme.Children.length > 1">
        <v-list-item
          v-for="(child, childIndex) in theme.Children"
          :key="`child-${childIndex}`"
          @click="onEventClick(child)"
        >
          <v-list-item-title>
            {{ child.EventTranslationName }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-row>
</template>

<script>
import { addLog } from '@/api/dssRequest';

export default {
  name: 'HeaderThemes',
  props: {
    isTransparent: Boolean,
  },
  computed: {
    themes() {
      return this.$store.getters['Account/themes'];
    },
  },
  methods: {
    onThemeClick(theme) {
      // Go to the first child upon theme click
      if (theme.Children.length === 0) {
        this.onEventClick(theme);
      } else {
        const [event] = theme.Children;
        this.onEventClick(event);
      }
    },
    onEventClick(event) {
      addLog(
        this.$store.getters['auth/userName'],
        event.EventId,
        'Event',
        'Header',
        -1
      );

      this.$router.push({
        name: 'EventDetails',
        params: { event_id: event.EventId },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.theme {
  cursor: pointer;
}
.theme:not(:last-child) {
  margin-right: 16px;
}
</style>
